import type { AdministrationAgreement } from '~/models'
import { PullService } from './servicePull'
import { getDoc } from 'firebase/firestore'

export class AdministrationAgreementPullService extends PullService<
  AdministrationAgreement,
  AdministrationAgreement[]
> {
  private doc

  constructor() {
    super()

    const { doc } = useFirebase()
    this.doc = doc
  }

  public async getAdministrationAgreementById(
    medicationAgreementId: string,
    administrationId: string,
  ): Promise<AdministrationAgreement> {
    const snapshot = await getDoc(
      this.doc<AdministrationAgreement>(
        'MedicationAgreement',
        medicationAgreementId,
        'AdministrationAgreement',
        administrationId,
      ),
    )

    if (!snapshot.exists()) {
      throw new Error(
        `AdministrationAgreement with ID ${administrationId} does not exist within MedicationAgreement ${medicationAgreementId}`,
      )
    }

    return snapshot.data() as AdministrationAgreement
  }
}
